module.exports = __webpack_public_path__ + "static/media/checkout-old.e4f07b7e.png";